export default __webpack_public_path__ + "static/media/love-icon-filled-rounded.21bd739e.svg";